module.exports = __webpack_public_path__ + "img/0527-i.3712b531.svg";